<template>
  <div class="ad">
    <div class="container">
      <div class="img-wrapper">
        <parallax :speedFactor="speed">
          <img src="../../assets/images/home/bg.jpg" alt="very cool bg" />
        </parallax>
      </div>
    </div>
    <div class="container absolute" @click="openOnto()">
      <div class="adtext">
        {{$t("runStatus.most")}}
      </div>
      <img src="../../assets/images/common/openonto.svg" />
    </div>
  </div>
</template>

<script>
import Parallax from "vue-parallaxy";
export default {
  components: {
    Parallax
  },
  data(){
    return{
      speed:0.3,
      sectionHeight:80,
    }
  },
  methods:{
      openOnto(){
          window.open("https://onto.app/")
      }
  }
  
};
</script>
<style scoped lang="less">
.Masthead__image.is-parallax>img{
  width: 106%;
  transform: translateX(-20px);
}
.ad {
  height: 100px;
  overflow: hidden;
  margin: 50px 0;
  position: relative;
  .container {
    height: 100%;
    border-radius: 4px;
    .img-wrapper{
      border-radius: 4px;
      height: 100px;
      overflow: hidden;
    }
  }
  .absolute {
      cursor: pointer;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    position:absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #0000004d !important;
    .adtext {
      top: 50%;
      left: 50%;
      font-size: 20px;
      font-family: Explorerfonts-Bold, SamsungSharpSans;
      font-weight: bold;
      color: rgba(255, 255, 255, 1);
      line-height: 26px;
    }
    img {
      height: 20px;
      padding-left: 20px;
      margin-bottom: 4px;
    }
  }
}

@media only screen and (max-width: 1080px) {
  .ad .absolute{
    width: 100%;
  }
  .ad .absolute img{
    padding-left: 0;
    padding-right: 20px;
  }
}
</style>
<style>
.Masthead__image.is-parallax>img{
    object-fit: contain !important;
}
</style>


// WEBPACK FOOTER //
// src/components/home/ad.vue